import { createAsyncThunk } from '@reduxjs/toolkit';
import { Order } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindOrder } from './interface';

export const findOrderExport = createAsyncThunk(
  'orderExport/findOrderExport', async (values: FindOrder, { rejectWithValue }) => {
    try {
      const response = await Order.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  })